import { render, staticRenderFns } from "./PendingTrainings.vue?vue&type=template&id=9f217ce4"
import script from "./PendingTrainings.vue?vue&type=script&lang=ts"
export * from "./PendingTrainings.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports